<template>
    <div>
        <div>
            <div class="mb-3 d-flex justify-content-between">
                <div class="">Lista de usuarios</div>
                <div class="row">
                    <label class="col-6">Filtrar por vendedor</label>

                    <div class="col-6">
                        <select
                            class="form-control"
                            v-model="filter"
                            v-on:change="listarUsuarios()"
                        >
                            <option selected="">Seleccione</option>
                            <option
                                v-for="vendedor in vendedores"
                                :key="vendedor.id"
                                :value="vendedor.id"
                            >
                                {{ vendedor.name }}
                            </option>
                            <option value="not_buy">No Comprados</option>
                            <option value="">No filtrar</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <section v-if="!initialLoading">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table
                                id="data-table-list-users"
                                class="table table-hover-animation table-striped table-bordered"
                            >
                                <caption>
                                    Lista de usuarios
                                </caption>
                                <thead>
                                    <tr>
                                        <th scope="col">ID</th>
                                        <th scope="col">Nombre</th>
                                        <th scope="col">Curso inscrito</th>
                                        <th scope="col">
                                            Fecha de inscripción
                                        </th>
                                        <th scope="col">Estado de compra</th>
                                        <th scope="col">Pago pendiente</th>
                                        <th scope="col">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(usuario, index) in this
                                            .usuarios"
                                        :key="index"
                                    >
                                        <td>{{ usuario.id }}</td>
                                        <td>
                                            <p>
                                                {{ usuario.name }}
                                            </p>
                                        </td>
                                        <td>
                                            <p
                                                v-if="
                                                    usuario.product_name != null
                                                "
                                            >
                                                {{ usuario.product_name }}
                                            </p>
                                            <el-tag
                                                v-else
                                                type="danger"
                                                disable-transitions
                                                >El usuario no se ha inscrito a
                                                ningun curso</el-tag
                                            >
                                        </td>
                                        <td>
                                            <span
                                                translate="no"
                                                class="notranslate"
                                                >{{
                                                    moment(usuario.created_at)
                                                        .format(
                                                            "DD/MM/YYYY hh:mm A"
                                                        )
                                                        .toString()
                                                }}</span
                                            >
                                        </td>
                                        <td>
                                            <el-tag
                                                v-if="
                                                    usuario.status == 0 ||
                                                    usuario.status == null
                                                "
                                                type="danger"
                                                disable-transitions
                                                >No comprado</el-tag
                                            >
                                            <el-tag
                                                v-else
                                                type="success"
                                                disable-transitions
                                                >Comprado</el-tag
                                            >
                                        </td>
                                        <td>
                                            <el-tag
                                                v-if="
                                                    usuario.pay_completed == 0
                                                "
                                                type="success"
                                                disable-transitions
                                                >Si</el-tag
                                            >
                                            <el-tag
                                                v-else-if="
                                                    usuario.pay_completed == 1
                                                "
                                                type="danger"
                                                disable-transitions
                                                >No</el-tag
                                            >
                                        </td>
                                        <!-- <td>
                                            <button @click="userInfo(usuario)" class="btn btn-primary">Info</button>
                                            <button @click="viewClassroom(usuario)" class="btn btn-primary">Ver aula</button>
                                        </td> -->
                                        <td>
                                            <el-select
                                                v-model="optionSelected"
                                                @change="
                                                    getOptionSelected(usuario)
                                                "
                                                clearable
                                                :remote-show-suffix="false"
                                                clear-icon
                                                id="customize_select"
                                            >
                                                <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                />
                                            </el-select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
            <custom-spinner v-else></custom-spinner>
        </div>
        <el-dialog
            v-model="showModalInfo"
            title="Información de usuario"
            width="70%"
        >
            <div>
                <strong class="px-3">Nombres:</strong
                >{{ usuarioSeleccionado.name }}
            </div>
            <div>
                <strong class="px-3">Tipo de documento:</strong
                >{{ usuarioSeleccionado.doc_type_name }}
            </div>
            <div>
                <strong class="px-3">Nro. de documento:</strong
                >{{ usuarioSeleccionado.number_doc }}
            </div>
            <div>
                <strong class="px-3">Correo:</strong
                >{{ usuarioSeleccionado.email }}
            </div>
            <div>
                <strong class="px-3">Teléfono:</strong
                >{{ usuarioSeleccionado.phone }}
            </div>
            <div>
                <strong class="px-3">Fecha de inscripción:</strong
                >{{
                    moment(usuarioSeleccionado.updated_at).format(
                        "DD/MM/YYYY hh:mm A"
                    )
                }}
            </div>
            <div>
                <strong class="px-3">Vendedor:</strong>{{ sellerInfo.name }}
            </div>
            <div class="py-2">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Curso</th>
                                <th scope="col">Fecha vencimiento</th>
                                <th scope="col">Pago pendiente</th>
                                <th scope="col">Acceso</th>
                                <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="delete">
                                <td colspan="3" class="text-center">
                                    Este usuario no tiene cursos comprados
                                </td>
                            </tr>
                            <tr v-for="curso in cursos" :key="curso.id">
                                <td>{{ curso.nombre }}</td>
                                <td>{{ formatDate(curso.created_at) }}</td>
                                <td>
                                    <el-tag
                                        v-if="curso.pay_completed == 0"
                                        type="warning"
                                        disable-transitions
                                        >Si</el-tag
                                    >
                                    <el-tag
                                        v-else
                                        type="success"
                                        disable-transitions
                                        >No</el-tag
                                    >
                                </td>
                                <td>
                                    <el-tag
                                        :type="
                                            curso.is_blocked == 0
                                                ? 'success'
                                                : 'danger'
                                        "
                                        disable-transitions
                                        >{{
                                            curso.is_blocked == 0
                                                ? "Habilitado"
                                                : "Bloqueado"
                                        }}</el-tag
                                    >
                                </td>
                                <td>
                                    <el-select
                                        v-if="curso.pay_completed == 0"
                                        v-model="optionSelected2"
                                        @change="getOptionSelected2(curso)"
                                        clearable
                                        :remote-show-suffix="false"
                                        clear-icon
                                        id="customize_select"
                                    >
                                        <el-option
                                            v-for="item in options2"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        />
                                    </el-select>
                                    <el-button
                                        type="primary"
                                        @click="extendDays(curso)"
                                    >
                                        Extender días
                                    </el-button>
                                </td>
                                <!-- <td>
                                    <button type="button" v-if="curso.pay_completed == 0" class="btn btn-primary" @click="payCourse(curso)">Pagar</button>
                                    <p v-else class="p-0 m-0">No aplica</p>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <template #footer>
                <span class="dialog-footer">
                    <el-button
                        v-if="delete"
                        @click="showConfirmModal = true"
                        type="danger"
                        >Eliminar</el-button
                    >
                    <el-button type="primary" @click="showModalInfo = false">
                        Cerrar
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog
            v-model="showPayModal"
            title="Pagar fraccionamiento"
            width="50%"
        >
            <div>
                <div>{{ courseSelected.nombre }}</div>
                <div>
                    <p class="py-1 m-0">
                        <strong>Precio del curso: </strong>S/.
                        {{ courseSelected.precio }}
                    </p>
                </div>
                <div>
                    <p class="py-1 m-0">
                        <strong>Monto acumulado actual: </strong>S/.
                        {{ courseSelected.total_paid }}
                    </p>
                </div>
                <div v-if="payAuth">
                    <label for="">Monto a aportar</label>
                    <input
                        v-model="amountPaid"
                        type="number"
                        name="amount"
                        id=""
                        class="form-control"
                    />
                </div>
                <div v-else>
                    <label for="">Monto a aportar</label>
                    <input
                        type="number"
                        name="amount"
                        id=""
                        class="form-control"
                        disabled
                    />
                    <p class="text-danger" style="word-break: normal">
                        El pago debe ser ingresado por el vendedor que registró
                        al usuario
                    </p>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="showPayModal = false"
                        >Cancelar</el-button
                    >
                    <el-button
                        v-if="payAuth"
                        type="primary"
                        @click="savePayment()"
                    >
                        Guardar
                    </el-button>
                    <el-button
                        v-else
                        type="primary"
                        @click="showPayModal = false"
                    >
                        Aceptar
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog
            v-model="showConfirmModal"
            title="Eliminar usuario"
            width="30%"
        >
            <span>¿Está seguro de eliminar este usuario?</span>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="showConfirmModal = false"
                        >Cancelar</el-button
                    >
                    <el-button type="primary" @click="eliminarUsuario()">
                        Confirmar
                    </el-button>
                </span>
            </template>
        </el-dialog>

        <el-dialog v-model="showModalDays" title="Extender días" width="40%">
            <span>Confirme el numero de dias que va a extender</span><br />
            <el-input-number v-model="this.days" />
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="showConfirmModal = false"
                        >Cancelar</el-button
                    >
                    <el-button type="primary" @click="extendDays2()">
                        Confirmar
                    </el-button>
                </span>
            </template>
        </el-dialog>

        <!-- <el-dialog
            v-model="showSalesModal"
            title="Vender curso"
            width="50%"
        >
            <div>
                <div>
                    <label for="">Seleccione un curso:</label>
                    <el-select
                    v-model="courseSelected"
                    clearable
                    :remote-show-suffix="false"
                    clear-icon
                    >
                        <el-option
                            v-for="item in courseList"
                            :key="item.id"
                            :label="item.nombre"
                            :value="item.id"
                        />
                    </el-select>
                </div>
                <div>
                    <p><strong>Precio de curso: </strong>{{  }}</p>
                </div>
                <div>
                    <label for="">Monto aportado</label>
                    <input type="number" name="" id="" v-model="amountPaid">
                </div>
                <div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="">
                      <label class="form-check-label" for="">
                        Pago fraccionado
                      </label>
                    </div>
                </div>
                <div class="text-center">
                    <button type="button">Guardar</button>
                </div>
            </div>
            <template #footer>
            <span class="dialog-footer">
                <el-button @click="showSalesModal = false">Cancelar</el-button>
                <el-button type="primary" @click="payCourse()">
                Confirmar
                </el-button>
            </span>
            </template>
        </el-dialog> -->
    </div>
</template>

<script>
import moment from "moment";
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";
export default {
    data() {
        return {
            initialLoading: false,
            usuarioSeleccionado: "",
            usuarios: [],
            days: 15,
            moment: moment,
            vendedores: [],
            filter: "",
            showModalInfo: false,
            showModalDays: false,
            showConfirmModal: false,
            delete: false,
            cursos: [],
            courseSelected: [],
            showPayModal: false,
            amountPaid: 0,
            optionSelected: "",
            optionSelected2: "",
            showSalesModal: false,
            courseList: [],
            sellerInfo: [],
            payAuth: false,
            url: "http://ipssoma.com/redirect/",
            //url: "http://127.0.0.1:8080/redirect/",
            options: [
                {
                    value: "1",
                    label: "Info",
                },
                {
                    value: "2",
                    label: "Ver aula",
                },
            ],
            options2: [
                {
                    value: "1",
                    label: "Pagar",
                },
                {
                    value: "2",
                    label: "Bloquear/Habilitar",
                },
            ],
        };
    },
    components: {
        "custom-spinner": CustomSpinner,
    },
    methods: {
        formatDate(date) {
            // Utiliza Moment.js o la API Date de JavaScript para formatear la fecha
            // Aquí hay un ejemplo utilizando Moment.js
            return moment(date).format("DD MMM YYYY");
        },
        loadDataTable() {
            $(document).ready(function () {
                $("#data-table-list-users").DataTable(language);
            });
        },
        getOptionSelected(usuario) {
            switch (this.optionSelected) {
                case "1":
                    this.userInfo(usuario);
                    break;
                case "2":
                    this.viewClassroom(usuario);
                    break;
                default:
                    break;
            }
            this.optionSelected = "";
        },
        getOptionSelected2(curso) {
            switch (this.optionSelected2) {
                case "1":
                    this.payCourse(curso);
                    break;
                case "2":
                    this.blockAccess(curso);
                    break;
                default:
                    break;
            }
            this.optionSelected2 = "";
        },
        async blockAccess(curso) {
            const form = {
                product_id: curso.id,
                payment_id: curso.payment_id,
            };
            await axios.patch("productos/bloquear-acceso", form).then((r) => {
                this.userInfo(this.usuarioSeleccionado);
                if (r.data == 0) {
                    this.$message.success("Se habilitó el acceso al usuario");
                } else {
                    this.$message.warning("Se bloqueó el acceso al usuario");
                }
            });
        },
        async sellCourse(usuario) {
            this.showSalesModal = true;
            await axios.get("/productos/list").then((r) => {
                this.courseList = r.data;
            });
        },
        payCourse(curso) {
            this.courseSelected = curso;
            this.showPayModal = true;
        },
        async savePayment() {
            if (this.validateData()) {
                const form = {
                    payment_id: this.courseSelected.payment_id,
                    amount: this.amountPaid,
                };
                await axios.post("/payments/fractioned/pay", form).then((r) => {
                    this.showPayModal = false;
                    this.listarUsuarios();
                    this.userInfo(this.usuarioSeleccionado);
                    this.amountPaid = 0;
                    this.$message.success("El pago se realizó correctamente");
                });
            }
        },
        validateData() {
            if (this.amountPaid == "") {
                this.$message.warning("Ingrese el monto a pagar");
                return false;
            }
            if (this.amountPaid <= 0) {
                this.$message.warning("Ingrese un monto adecuado");
                return false;
            }
            return true;
        },
        async eliminarUsuario() {
            const form = {
                user_id: this.usuarioSeleccionado.id,
            };
            await axios.post(`usuarios/eliminar`, form).then((response) => {
                this.listarUsuarios();
            });
            this.showConfirmModal = false;
            this.showModalInfo = false;
            this.$message.success("Usuario eliminado satisfactoriamente");
        },
        async userInfo(user) {
            this.cursos = [];
            this.delete = false;
            this.sellerInfo = [];
            this.payAuth = false;
            this.usuarioSeleccionado = user;
            if (user.product_name != null) {
                await axios
                    .get(`/usuarios/verificar?user_id=${user.id}`)
                    .then((response) => {
                        this.cursos = response.data.purchaseds;
                        this.delete = response.data.delete;
                        this.sellerInfo = response.data.seller_info;
                        this.payAuth = response.data.pay_auth;
                    });
            }
            this.showModalInfo = true;
        },
        async extendDays(curso) {
            this.days = 15;
            this.courseSelected = curso;
            this.showModalDays = true;
        },
        async extendDays2() {
            if (this.days > 0) {
                const formdata = new FormData();
                formdata.append("user_id", this.usuarioSeleccionado.id);
                formdata.append("course_id", this.courseSelected.id);
                formdata.append("days", parseInt(this.days));
                try {
                    this.loading = true;
                    const request = await axios({
                        url: "usuarios/extender-dias",
                        method: "post",
                        data: formdata,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });
                    const response =
                        request.status == 200
                            ? this.$message.success(
                                  "Se ha procesado correctamente"
                              )
                            : await this.$message.warning(
                                  "Error al validar datos"
                              );
                    this.showModalDays = false;
                    this.userInfo(this.usuarioSeleccionado);
                } catch (error) {
                    console.log(error);
                }
            } else {
                alert("No puede ingresar numeros negativos ni cero");
            }
        },
        async listarUsuarios() {
            this.initialLoading = true;
            const form = {
                seller_id: this.filter,
            };
            await axios.post("/usuarios/listar", form).then((response) => {
                this.usuarios = response.data;
                this.loadDataTable();
                this.initialLoading = false;
            });
        },
        async listarVendedores() {
            await axios.get("/usuarios/vendedores/listar").then((response) => {
                this.vendedores = response.data;
            });
        },
        async viewClassroom(user) {
            await axios
                .get(`/user/${user.id}/view-classroom`)
                .then((response) => {
                    // window.location.href = `${this.url}${response.data}`;
                    window.open(`${this.url}${response.data}`, "_blank");
                });
        },
    },
    mounted() {
        this.listarUsuarios();
        this.listarVendedores();
    },
};
</script>
